import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { AmazingTimePickerService } from '../../atp-library/atp-time-picker.service';

@Component({
    selector: 'pcg-clock-picker',
    templateUrl: './clock-picker.component.html',
    styleUrls: ['./clock-picker.component.scss'],
    standalone: false
})
export class ClockPickerComponent {

	@Input() id: string;
	// tslint:disable-next-line:no-input-rename
	@Input('value') _value = '';
	@ViewChild('clockPicker') clockPicker: ElementRef;
	isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g);
	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(private atp: AmazingTimePickerService) { }

	writeValue(obj: any): void {
		this.value = obj;
	}
	registerOnChange(fn: any): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
	setDisabledState?(isDisabled: boolean): void {
		this.clockPicker.nativeElement.isDisabled = isDisabled;
	}

	open() {
		const amazingTimePicker = this.atp.open();
		amazingTimePicker.afterClose().subscribe(time => {
			this.value = time;
		});
	}

	formatValue(val) {
		if (val?.split(':').length === 2) {
			const nums = val.split(':').map(i => parseInt(i, 10));
			return new Date(0, 0, 0, nums[0], nums[1]).toLocaleTimeString().replace(':‎00‎ ', ' ');
		}
		return '';
	}
}
